import type { FaireProductEntity } from "../../entity_types/product";

export const p_ss3bq4dabj: FaireProductEntity = {
  token: "p_ss3bq4dabj",
  type: "product",
  name: "You're So Nice",
  brandToken: "b_qat8n5mmyf",
  brandName: "Willow & Ivy Press",
  imageUrl:
    "https://cdn.faire.com/fastly/e6ed108c7a8a1b39463f704fef6d02f3fcd76aaf19339f0f4a4fcbe1ad356a95.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea01211eee0a881fac1694b96f442de1cd24f6712511452dea3ea9fb9eee8924.png",
    "https://cdn.faire.com/fastly/26312838c6db54fcb215f5c46efae96a03213c801644fc77e53239cdd3961a53.jpeg",
  ],
  priceDollars: 18,
  description:
    "Willow & Ivy Greeting Cards print on heavy, uncoated paper stock with foil, glitter, and die-cut embellishments. Each card includes a Champagne Gold Pearlized envelope for a timeless look and touch. All cards are made in the USA.\n\n• 6 Cards & Envelopes per unit\n• Wholesale: $18.00/unit\n• Retail: $6.00 each\n\nPlease note: Cards are not individually cello-wrapped and include the retail price printed on the back.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:05.689Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
